import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  key: Yup.string().required("Please enter a key!"),
  value: Yup.string().required("Please enter a value!"),
  botServiceID: Yup.string().required("Please select a Bot Service!"),
});

export default validationSchema;
